import { ApolloLink } from "@apollo/client";
import createSplitBySchemaLink from "./createSplitBySchemaLink";
const WILDCARD = '*';
const errorLink = new ApolloLink(function errorLink() {
    throw new Error('Wildcard schema exists (*) but does not have an apollo link assigned. Please make sure to assign an apollo link to it.');
});
export default function createRouteToTestOrRealSchemaLink(schemaLinksConfiguration) {
    const wildcardConfig = Object.keys(schemaLinksConfiguration.schemaIdToApolloLink).find((schemaId)=>schemaId === WILDCARD);
    const rightLink = wildcardConfig ? schemaLinksConfiguration.schemaIdToApolloLink[wildcardConfig] : errorLink;
    return ApolloLink.split(()=>typeof wildcardConfig === 'undefined', createSplitBySchemaLink(schemaLinksConfiguration), rightLink);
}

//# sourceMappingURL=createRouteToTestOrRealSchemaLink.js.map